import { io } from 'socket.io-client';

// local
//export const socket = io('http://localhost:8000');

// prod
export const socket = io('https://conurbano-stories.2gstudio.com.ar', { path: '/api/socket.io' });